export default {
  main: '#3B623B',
  secondary: '#5B955B',
  contrastingColor: '#ffffff',
  priceColor: '#5B955B',
  entryBackground: '#3B623B',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
